import { type Common } from './common.js';
import type * as InsuranceRteRequest from './models/insuranceRteRequest.js';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(
    query?: InsuranceRteRequest.FindAllOptions
  ): Promise<InsuranceRteRequest.InsuranceRteRequest[]> {
    const url = this.common.constructPath('/insurance-rte-requests', query);
    return await this.common.getJSON(url);
  }
}
